module.exports = __webpack_public_path__ + "static/media/NokiaZinaIndia.e1116981.svg";